/**
 * Search rotating placeholder
 * Initializes rotating placeholder terms in the header search bar and search drawer.
 * Reads terms from data-rotating-placeholder-terms (comma or newline separated).
 */
(function() {
  'use strict';

  var ROTATE_MS = 2800;
  var FADE_MS = 300;
  var FADE_MS_DRAWER = 350;

  var ATTR = {
    headerTrigger: 'data-header-search-trigger',
    headerPlaceholderRotate: 'data-header-search-placeholder-rotate',
    rotatingPlaceholderTerms: 'data-rotating-placeholder-terms',
    rotatingPlaceholderInput: 'data-rotating-placeholder-input',
    rotatingPlaceholderText: 'data-rotating-placeholder-text',
    focused: 'data-focused',
    hasValue: 'data-has-value'
  };

  function sel(attr) {
    return '[' + attr + ']';
  }

  function parseTerms(str) {
    var termsStr = (str || '').trim();
    var rawTerms = termsStr ? termsStr.split(/[\r\n,]+/).map(function(s) { return s.trim(); }).filter(Boolean) : [];
    return rawTerms.map(function(t) { return (t.replace(/^Search\s+/i, '') || t).trim(); });
  }

  function initHeaderSearchTrigger() {
    var trigger = document.querySelector(sel(ATTR.headerTrigger));
    if (!trigger) return;
    var textEl = trigger.querySelector(sel(ATTR.headerPlaceholderRotate));
    if (!textEl) return;

    var terms = parseTerms(trigger.getAttribute(ATTR.rotatingPlaceholderTerms));
    if (terms.length === 0) return;

    var index = 0;
    var intervalId = null;

    function showTerm(i) {
      textEl.textContent = terms[i] != null ? terms[i] : terms[0];
      textEl.style.opacity = '1';
    }

    function nextTerm() {
      textEl.style.opacity = '0';
      setTimeout(function() {
        index = (index + 1) % terms.length;
        showTerm(index);
      }, FADE_MS);
    }

    function startRotation() {
      if (intervalId || terms.length === 0) return;
      showTerm(index);
      intervalId = setInterval(nextTerm, ROTATE_MS);
    }

    showTerm(0);
    startRotation();
  }

  function initSearchDrawer() {
    var drawer = document.getElementById('search-drawer');
    if (!drawer) return;
    var block = drawer.querySelector(sel(ATTR.rotatingPlaceholderTerms));
    var input = block && block.querySelector(sel(ATTR.rotatingPlaceholderInput));
    var placeholderEl = block && block.querySelector(sel(ATTR.rotatingPlaceholderText));
    if (!block || !input || !placeholderEl) return;

    var terms = parseTerms(block.getAttribute(ATTR.rotatingPlaceholderTerms));
    if (terms.length === 0) return;

    var index = 0;
    var intervalId = null;

    function showTerm(i) {
      placeholderEl.textContent = terms[i] != null ? terms[i] : terms[0];
      placeholderEl.style.opacity = '1';
    }

    function nextTerm() {
      placeholderEl.style.opacity = '0';
      setTimeout(function() {
        index = (index + 1) % terms.length;
        showTerm(index);
      }, FADE_MS_DRAWER);
    }

    function startRotation() {
      if (intervalId || terms.length === 0) return;
      block.removeAttribute(ATTR.focused);
      block.removeAttribute(ATTR.hasValue);
      showTerm(index);
      intervalId = setInterval(nextTerm, ROTATE_MS);
    }

    function stopRotation() {
      if (intervalId) {
        clearInterval(intervalId);
        intervalId = null;
      }
      block.setAttribute(ATTR.focused, '');
      if (input.value.trim().length > 0) block.setAttribute(ATTR.hasValue, '');
    }

    function onFocus() {
      stopRotation();
    }

    function onBlur() {
      if (input.value.trim().length === 0) {
        startRotation();
      } else {
        block.setAttribute(ATTR.hasValue, '');
      }
    }

    function onInput() {
      if (input.value.trim().length > 0) {
        block.setAttribute(ATTR.hasValue, '');
        if (intervalId) {
          clearInterval(intervalId);
          intervalId = null;
        }
      } else {
        block.removeAttribute(ATTR.hasValue);
      }
    }

    input.addEventListener('focus', onFocus);
    input.addEventListener('blur', onBlur);
    input.addEventListener('input', onInput);

    if (terms.length > 0) {
      if (!document.hasFocus || document.hasFocus()) {
        startRotation();
      } else {
        showTerm(0);
        setTimeout(startRotation, 100);
      }
    }
  }

  function init() {
    initHeaderSearchTrigger();
    initSearchDrawer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
